<template>
    <div>
    <NavBar :user="user" v-on:openProblem="openProblem($event)" v-on:login="login" v-on:logout="logout" v-on:ai-session-activated="showAISessionModal"/>
    <main>
      <SearchItem v-on:refresh="refresh($event)" v-bind:facets="facets"/>
      <Total v-bind:total="total"/>
      <div class="album py-5 bg-light" v-show="total > 0">
        <div class="container">
          <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
            <div class="col" v-for="problem in problems" :key="problem.publicID">
              <ProblemCard  :publicID='problem.publicID' 
                            :problem='problem'
                            :isEditor='isEditor'
                            v-on:openProblem="openProblem($event)"
                            v-on:editProblem="editProblem($event)"
                            v-on:openGearModal="openGearModal($event)"/>
            </div>
          </div>
          <GearModal :gearProblem='gearProblem'/>
        </div>
      </div>
    </main>
    <Footer/>
    
    <b-modal id="ai-session-activated" hide-footer hide-header>
      <div class="text-center">
        <h3 class="text-success mb-3">
          <i class="bi bi-stars" style="font-size: 2rem;"></i>
        </h3>
        <h4 class="text-success">Mode IA activé</h4>
        <p class="text-muted mt-3">
          L'accès à la génération IA est activé pour 5 minutes.
        </p>
        <p class="text-muted small">
          Vous pouvez maintenant utiliser le bouton IA sur les pages de problèmes.
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import algoliasearch from 'algoliasearch/lite'
const client = algoliasearch('DVBDAFL4J1', 'f9223f73a10d20f16ce090b0f7789f4b')
const index = client.initIndex('problems')

import NavBar from '@/components/NavBar.vue'
import SearchItem from '@/components/SearchItem.vue'
import ProblemCard from '@/components/ProblemCard.vue'
import Footer from '@/components/Footer.vue'
import Total from '@/components/Total.vue'
import GearModal from '@/components/GearModal.vue'
import { openProblem, editProblem } from '../utils'
import { googleLogin, signOut, onAuthStateChanged } from '../auth/firebase'

export default {
  name: 'Home',
  data() {
    return {
      problems: [],
      total: 0,
      user: null,
      facets: {
        'level': { 'CP': 0, 'CE1': 0, 'CE2': 0, 'CM1': 0, 'CM2': 0 },
        'category': { 'ADD': 0, 'MUL': 0, 'DIV': 0, 'NUM': 0, 'PROP': 0 },
        'complexity': { 'one': 0, 'more': 0, 'atypique': 0 },
        'domain': { 'INT': 0, 'DEC': 0, 'FRAC': 0, 'GEO': 0, 'LOGOS': 0 },
        'typoAdd': { 'trans': 0, 'compos': 0, 'compos-de-trans': 0, 'compar': 0 },
        'typoDiv': { 'partition': 0, 'quotition': 0 },
        'typoMul': { 'rect': 0, 'cartesian': 0, 'n-times': 0 }
      },
      gearProblem: {
        publicID: null,
        level: null,
        category: null,
        domain: null,
        complexity: null
      }
    }
  },
  components: {
    NavBar,
    SearchItem,
    ProblemCard,
    Footer, 
    Total,
    GearModal
  },
  async created() { 
    this.user = await onAuthStateChanged(this.db)
  },
  computed: {
    isEditor() {
      let isEditor = false
      if(this.user) { isEditor = this.user.isEditor }
      return isEditor 
    }
  },
  methods: {
      openProblem: openProblem,
      editProblem: editProblem,
      async login() { this.user = await googleLogin(this.db) },
      async logout() { let isSignedOut = await signOut(); if(isSignedOut) { this.user = null } },
      openGearModal(gearProblem) {
        this.gearProblem = gearProblem
        this.$bvModal.show('gear-modal')
      },
      refresh(filters) { 
        index.search('', { hitsPerPage: 1000, filters: filters }).then(({ hits }) => { this.problems = hits }) 
      },
      showAISessionModal() {
        this.$bvModal.show('ai-session-activated')
        // Auto-hide modal after 3 seconds
        setTimeout(() => {
          this.$bvModal.hide('ai-session-activated')
        }, 3000)
      }
  },
  firestore() { return { problems: this.db.collection('problems') } },
  watch: { problems() {
      this.total = this.problems.length
      this.facets = {
        'level': { 'CP': 0, 'CE1': 0, 'CE2': 0, 'CM1': 0, 'CM2': 0 },
        'category': { 'ADD': 0, 'MUL': 0, 'DIV': 0, 'NUM': 0, 'PROP': 0 },
        'complexity': { 'one': 0, 'more': 0, 'atypique': 0 },
        'domain': { 'INT': 0, 'DEC': 0, 'FRAC': 0, 'GEO': 0, 'LOGOS': 0 },
        'typoAdd': { 'trans': 0, 'compos': 0, 'compos-de-trans': 0, 'compar': 0 },
        'typoDiv': { 'partition': 0, 'quotition': 0 },
        'typoMul': { 'rect': 0, 'cartesian': 0, 'n-times': 0 }
      }
      for(let problem of this.problems) {
        const { level, category, domain, complexity, typoAdd, typoMul, typoDiv } = problem
        this.facets.level[level] ++
        this.facets.category[category] ++
        this.facets.domain[domain] ++
        this.facets.complexity[complexity] ++
        if(typoAdd) { this.facets.typoAdd[typoAdd] ++ }
        if(typoMul) { this.facets.typoMul[typoMul] ++ }
        if(typoDiv) { this.facets.typoDiv[typoDiv] ++ }
      }
    }
  }
}
</script>

<style scoped>
  /* bootstrap-vue fixing */
  .col {
    margin-top: 16px;
    padding-left: 30px;
  }
  div.col {
    padding: 0px 8px 0px 8px;
  }
</style>